<template>
  <v-container class="layout-container">
    <Settings />
  </v-container>
</template>

<script>
export default {
  components: {
    Settings: () => import('@/modules/settings')
  }
}
</script>
